var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_voice"},[_c('div',[_c('img',{staticClass:"_microphone",attrs:{"src":_vm.microphonePng}}),_vm._v(" "),_c('div',{staticClass:"_volumeAnimation"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e513c7e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/element/ipsosWxYy.vue
// module id = null
// module chunks = 